<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" scrollable>
      <v-form ref="formRegularizar" v-model="valid" lazy-validation @submit.prevent="saveData">
        <v-card v-if="ins_temp">
          <v-toolbar flat dark color="primary" class="max-height">
            <v-toolbar-title> Detalle de Plan de Pagos</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="closeDialog"> <v-icon>mdi-close</v-icon></v-btn>
          </v-toolbar>
          <v-card-text>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  type="number"
                  v-model.number="monto_regularizar"
                  outlined
                  dense
                  autofocus
                  label="Monto a Regularizar"
                  background-color="#ffe17694"
                  :rules="[rules.loanMin, rules.required]"
                  @keyup="autoLoadItems"
                  hide-details
                />
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="form.motivo"
                  :rules="[rules.required_2]"
                  outlined
                  dense
                  label="Motivo"
                  item-text="descripcion"
                  :items="motivos"
                  return-object
                >
                </v-select>
              </v-col>
              <v-col cols="12">
                <v-textarea rows="2" type="number" :rules="[rules.required_2]" v-model="form.descripcion" outlined dense label="Descripcion" />
              </v-col>
              <v-col class="px-4">
                <!-- <h4>Descripcion de la regulacion</h4> -->
                <p class="my-0 py-0">
                  <span class="red--text font-weight-bold">NOTA:</span> La solicitud de regularización esta pendiente de aprobación de contabilidad nacional.
                </p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" xl="6" md="6" lg="6" class="py-0">
                <v-data-table
                  v-if="ins_temp.plan_pagos"
                  :headers="headers"
                  :items="ins_temp.plan_pagos"
                  hide-default-footer
                  disable-pagination
                  class="elevation-10"
                >
                  <template v-slot:top> <p class="h4 text-center pt-2 black--text">PLAN DE PAGOS ACTUAL</p></template>
                  <template v-slot:no-data>
                    <div role="listbox" tabindex="-1" class="v-list v-select-list v-sheet theme--light v-list--dense theme--light">
                      <div tabindex="-1" class="v-list-item theme--light">
                        <div class="v-list-item__content">
                          <div class="v-list-item__title">ESTE ESTUDIANTE NO TIENE PLAN DE PAGOS</div>
                        </div>
                      </div>
                    </div>
                  </template>
                </v-data-table>
              </v-col>
              <v-col v-if="!!items.length" cols="12" xl="6" md="6" lg="6" class="py-0">
                <v-data-table :headers="headersItems" :items="items" class="elevation-10" hide-default-footer disable-pagination>
                  <template v-slot:top> <p class="h3 text-center pt-2 text-primary">CUOTAS A REGULARIZAR</p></template>
                  <template v-slot:[`item.monto_r`]="{ item }">
                    <v-text-field
                      :disabled="!item.editable"
                      type="number"
                      v-model.number="item.monto_r"
                      outlined
                      dense
                      @change="updateTotal"
                      :rules="[rules.required, rules.loanMin, rules.loanMax(item.monto_r, item.saldo)]"
                      :max="item.saldo"
                    ></v-text-field>
                  </template>
                  <template v-slot:footer>
                    <v-row justify="center" class="mx-2">
                      <v-col md="4" sm="6" xl="12"> <v-text-field v-model="form.monto" outlined dense readonly label="TOTAL (BS.)"></v-text-field></v-col>
                    </v-row>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider class="mt-0"></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn type="submit" :loading="enviando" color="success" v-if="items.length" rounded>
              <v-icon class="mr-1"> mdi-content-save</v-icon> Solicitar Regularizacion
            </v-btn>
            <v-btn color="blue darken-1" outlined rounded @click="closeDialog"> Cancelar <v-icon> mdi-close</v-icon> </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-row>
</template>
<script>
import xaxios from '@/xaxios';
import { mapState } from 'vuex';
export default {
  data() {
    return {
      rules: {
        required_2: (value) => !!value || 'El campo es obligatorio',
        required: (value) => !!value || 'Se requiere un monto a regularizar',
        loanMin: (value) => value >= 0 || 'Monto debe ser mayor a 0',
        loanMax: (m, s) => m <= s || 'Monto no puede ser mayor al saldo de ' + s,
      },
      api_rest: process.env.VUE_APP_API_REST,

      valid: false,
      enviando: false,
      dialog: false,
      ins_temp: null,
      monto_regularizar: 0,
      headers: [
        // { text: 'Codigo Cuota', value: 'plan_pago_id' },
        { text: 'Concepto', value: 'concepto_pago.nombre' },
        { text: 'N°Cuota', value: 'nro_cuota' },
        { text: 'Monto', value: 'monto' },
        // { text: 'Descuento', value: 'descuento' },
        { text: 'Saldo', value: 'saldo' },
        { text: 'Fecha Pago', value: 'date_pago' },
      ],
      headersItems: [
        { text: 'Concepto de pago', value: 'concepto_pago.nombre' },
        { text: 'N° Cuota', value: 'nro_cuota' },
        { text: 'Monto', value: 'monto_r' },
      ],
      items: [],
      motivos: [],
      form: {
        descripcion: '',
        monto: 0,
        motivo: null,
      },
    };
  },
  watch: {
    dialog(val) {
      val || this.closeDialog();
    },
  },
  computed: {
    ...mapState({
      UNIDAD_NEGOCIO_ID: (state) => state.UNIDAD_NEGOCIO_ID,
    }),
  },

  methods: {
    showThisView(inscripcion) {
      inscripcion.plan_pagos = inscripcion.plan_pagos.sort((a, b) => {return a.xorder - b.xorder || a.nro_cuota - b.nro_cuota;})
      window.console.log('inscripcion::',inscripcion.plan_pagos);
      
      this.ins_temp = inscripcion;
      this.dialog = true;
      this.get_motivos(this.UNIDAD_NEGOCIO_ID, 1);
      // window.console.log(JSON.stringify(this.ins_temp));
    },
    async saveData() {
      if (this.$refs.formRegularizar.validate()) {
        if (await this.$root.$confirm_text.open('Solicitar Regularizacion', 'Estas seguro de los datos a solicitar?', 'aprobar', { color: 'red' })) {
          let formData = {
            descripcion: this.form.descripcion,
            inscripcion_id: this.ins_temp.id,
            monto: this.form.monto,
            motivo_id: this.form.motivo.id,
          };
          const url = `${this.api_rest}/api/v1/inscripcion/pagos/regularizacion/v2`;
          // window.console.log(JSON.stringify(formData), 'data sended', url);
          if (this.ins_temp.estado_ins == 1) {
            this.enviando = true;
            xaxios
              .post(url, formData)
              .then((response) => {
                if (response.status === 200) {
                  this.$root.$notify.show(`${response.data.data}`, { color: 'success', timeout: 5000 });
                  this.closeDialog();
                  this.$emit('closeDialog');
                } else {
                  this.$root.$notify.show(`Ocurrio un error nose puede aplicar regularizacion`, { color: 'red', timeout: 5000 });
                }
              })
              .catch((error) => {
                this.enviando = false;
                window.console.log(JSON.stringify(error));
                this.$root.$notify.show(`${error.response ? error.response.data.error : 'Error en la Transaccion'}`, { color: 'red', timeout: 5000 });
              });
          } else {
            this.$root.$notify.show(`${'El Estudiante no se encuentra en estado "INSCRITO"'}`, { color: 'red' });
          }
        }
      }
    },

    get_motivos(unidad_negocio_id, descuento_tipo_id) {
      xaxios
        .get(`${this.api_rest}/api/v1/motivos?unidad_negocio_id=${unidad_negocio_id}&descuento_tipo_id=${descuento_tipo_id}&estado=${true}`)
        .then(({ data }) => (this.motivos = data ? data.data : []));
    },
    autoLoadItems() {
      this.items = [];

      let xt =  this.monto_regularizar;
      let incluye = (xt + '').includes('.');
      let termina = (xt + '').endsWith('.');
      if (incluye && !termina) xt = Math.round((this.monto_regularizar + Number.EPSILON) * 100) / 100;

      this.monto_regularizar = xt;
      //this.monto_regularizar = this.monto_regularizar ? parseFloat(this.monto_regularizar) : 0;
      if (this.monto_regularizar) {
        let auxArray = this.ins_temp.plan_pagos.filter((item) => item.saldo > 0);
        // auxArray.sort((a, b) => {return a.order - b.order || a.numero_cuota - b.numero_cuota;})
        let monto = this.monto_regularizar;

        for (let i = auxArray.length; i > 0; i--) {
          let firstElement = auxArray.shift();
          if (monto > 0 && firstElement.saldo > 0) {
            this.addItems(firstElement, monto >= firstElement.saldo ? firstElement.saldo : monto);
            monto = monto - (monto >= firstElement.saldo ? firstElement.saldo : monto);
          }
        }
      }
    },
    addItems(cuota, monto = 0) {
      this.items.sort((a, b) => a.numero_cuota - b.numero_cuota);
      cuota.pago = cuota.monto;
      cuota.monto_r = monto ? monto : cuota.saldo;
      this.items.push(cuota);

      this.updateTotal();
    },
    updateTotal() {
      this.form.monto = 0;
      this.items.forEach((item) => (this.form.monto += +item.monto_r));
      this.form.monto = parseFloat(this.form.monto.toFixed(2));
    },

    closeDialog() {
      this.ins_temp = null;
      this.items = [];
      this.motivos = [];
      this.monto_regularizar = 0;
      this.form = {
        monto: 0,
        descripcion: '',
        motivo: null,
      };
      this.enviando = false;
      this.dialog = false;
    },
  },
};
</script>

<style>
</style>